import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { SalesDiscountProductType } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SalesDiscountProductTypeService extends TmsWebBaseEditCreateService<
  SalesDiscountProductType,
  SalesDiscountProductType
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('SalesDiscountProductType', $localize`Sales Discount Product Type`);
  }
}
